import { render, staticRenderFns } from "./relacionarColumnas.vue?vue&type=template&id=7ff2f31b&scoped=true&"
import script from "./relacionarColumnas.vue?vue&type=script&lang=js&"
export * from "./relacionarColumnas.vue?vue&type=script&lang=js&"
import style0 from "./relacionarColumnas.vue?vue&type=style&index=0&id=7ff2f31b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2f31b",
  null
  
)

export default component.exports